<div class="min-h-screen bg-[#274693] flex items-center justify-center px-6">
  <div class="absolute -right-20 -top-20 z-0">
    <svg width="502" height="563" viewBox="0 0 502 563" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2852_12228)">
        <path d="M13.2822 403.563L211.017 562.999L502 429.795L306.445 266.203L13.2822 403.563Z" fill="#0F3066"></path>
        <path d="M13.2822 403.564L306.445 266.204L290.506 0L0 139.677L13.2822 403.564Z" fill="#184A9F"></path>
        <path d="M306.445 266.204L502 429.796L484.631 166.386L290.506 0L306.445 266.204Z" fill="#133C80"></path>
      </g>
      <defs>
        <clipPath id="clip0_2852_12228">
          <rect width="502" height="563" fill="white"></rect>
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="bg-white rounded-xl w-full max-w-sm p-8 flex flex-col items-center text-center z-10">
    <img src="assets/images/logo.svg" alt="Logo" class="w-48 mb-6">
    <h2 class="text-xl text-neutral-900 font-semibold mb-2">Connexion requise</h2>
    <p class="text-neutral-500 text-sm mb-6">Connectez-vous avec votre compte Microsoft <span class="font-semibold text-neutral-700">@cityzmedia.fr</span> pour accéder à Cityz Studio.</p>
    @if (errorMessage(); as msg) {
      <div class="p-3 mb-4 w-full bg-red-50 text-red-600 text-xs rounded-lg border border-red-100">{{ msg }}</div>
    }
    <button
      type="button"
      (click)="onLoginMicrosoft()"
      [disabled]="isLoading()"
      class="rounded-full border border-neutral-200 bg-white px-4 py-3 text-neutral-900 w-full flex items-center justify-center gap-3 transition-all hover:bg-neutral-50"
      [class.opacity-70]="isLoading()"
    >
      @if (isLoading()) {
        <span class="inline-block size-5 rounded-full border-4 border-black/40 border-t-black animate-spin"></span>
        Chargement...
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23 23" class="size-5 shrink-0">
          <path fill="#f3f3f3" d="M0 0h23v23H0z"/>
          <path fill="#f35325" d="M1 1h10v10H1z"/>
          <path fill="#81bc06" d="M12 1h10v10H12z"/>
          <path fill="#05a6f0" d="M1 12h10v10H1z"/>
          <path fill="#ffba08" d="M12 12h10v10H12z"/>
        </svg>
        Se connecter avec Microsoft
      }
    </button>
  </div>
</div>
